import { render } from "./LogoCarousel.vue?vue&type=template&id=1d2705d8"
import script from "./LogoCarousel.vue?vue&type=script&lang=js"
export * from "./LogoCarousel.vue?vue&type=script&lang=js"

import "./LogoCarousel.vue?vue&type=style&index=0&id=1d2705d8&lang=scss"

import exportComponent from "/Users/tome/devbox/tz-razanac.test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__